import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HeaderService } from './header.service';
import { AlertService } from '../alert/alert.service';
import { Subscription } from 'rxjs';
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/guards/auth.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  logout:boolean = false;
  callCare:boolean = false;
  isToggled: boolean = true;

  subscription: Subscription | undefined;
  isIncidentAssigned: boolean = false;
  constructor( public dialog: MatDialog,
     public router: Router,
     public commonServices: AppService,
     public mainService: AppService,
     public headerService: HeaderService,
     public alertServices: AlertService,
     private sessionService:AuthService) {
  }
  ngOnInit() {  
  }







  ngOnDestroy() {
    this.subscription && this.subscription.unsubscribe();
  }
  payload:boolean = false
  openSideNav(name:any) {
    if(name == 'sidenav'){
      this.isToggled = !this.isToggled;
      this.payload = this.isToggled
    }else if(name == 'callCare'){
    this.callCare = !this.callCare 
    this.payload = this.callCare  
    }
    let obj={
      'isToggled':this.payload,
       'callCare':name
    }
    this.mainService.sideNavToggle.next(obj)
  }
  
  logOut(): void {
    this.sessionService.logout();     
    this.router.navigate(['/login']);
    this.logout=false;    
    this.alertServices.info("User logged out")
    this.commonServices.cadStatusData.next(this.logout)
  }

}
